import { API_URL } from "../../config/api";

/**
 * Parse images field từ backend (string JSON, string đơn, hoặc array)
 * thành mảng URL đầy đủ.
 */
export function parsePropertyImages(images) {
  if (!images) return [];

  let parsed = [];

  if (Array.isArray(images)) {
    parsed = images;
  } else if (typeof images === "string") {
    const trimmed = images.trim();
    if (trimmed.startsWith("[")) {
      try {
        const result = JSON.parse(trimmed);
        if (Array.isArray(result)) parsed = result;
      } catch (err) {
        console.error("Không parse được images JSON:", err);
      }
    } else {
      parsed = [trimmed];
    }
  }

  return parsed.map((img) =>
    img.startsWith("http") ? img : `${API_URL}${img.startsWith("/") ? "" : "/"}${img}`
  );
}

/**
 * Chuyển mảng URL đầy đủ về relative path để gửi lên backend.
 */
export function serializePropertyImages(existingImages, newUrls = []) {
  return JSON.stringify([
    ...existingImages.map((url) => url.replace(API_URL, "")),
    ...newUrls,
  ]);
}